<template>
  <div class="e-sidebar" :class="classes">
    <button class="sidebar-overlay" @click="closeMobile" aria-label="Close menu"></button>
    <div class="sidebar-container">
      <div class="topline">
        <a href="#">
          <svg class="logo open" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 275 76" style="enable-background:new 0 0 275 76;" xml:space="preserve">
            <g>
              <path class="st0" d="M93.7,27.4c-6.1,0-10.5,4.6-10.5,10.4v0.1c0,6.2,4.6,10.3,11.1,10.3c4.1,0,7-1.6,9-4l-4-3.2
                c-1.5,1.4-2.9,2-4.6,2c-2.3,0-3.9-1.1-4.5-3.3h13.9c0-0.5,0-1,0-1.4C104.2,32.5,100.9,27.4,93.7,27.4z M90.1,36.2
                c0.4-2.2,1.7-3.6,3.6-3.6c2,0,3.3,1.4,3.6,3.6H90.1z M118,42.3c-2.5,0-4.1-1.9-4.1-4.5v-0.1c0-2.4,1.7-4.4,4.1-4.4
                c1.8,0,2.9,0.8,3.9,2.1l4.9-3.5c-1.8-2.7-4.6-4.4-8.9-4.4c-6.6,0-11.1,4.7-11.1,10.3v0.1c0,5.6,4.6,10.3,10.9,10.3
                c4.6,0,7.3-1.8,9.2-4.6l-4.9-3.4C120.8,41.6,119.7,42.3,118,42.3z M139.8,27.4c-6.7,0-11.5,4.7-11.5,10.4v0.1
                c0,5.6,4.8,10.3,11.4,10.3c6.7,0,11.5-4.7,11.5-10.4v-0.1C151.3,32.1,146.5,27.4,139.8,27.4z M144.2,37.9c0,2.4-1.7,4.4-4.3,4.4
                c-2.6,0-4.4-2.1-4.4-4.5v-0.1c0-2.4,1.7-4.4,4.3-4.4C142.3,33.3,144.2,35.4,144.2,37.9L144.2,37.9z M168.3,27.4
                c-3,0-4.9,1.6-6.2,3.2v-2.8h-7.3v19.8h7.3V37c0-2.2,1.3-3.3,3.1-3.3c1.7,0,2.9,1.2,2.9,3.3v10.7h7.3v-13
                C175.4,30.2,172.7,27.4,168.3,27.4z M190.3,27.4c-6.7,0-11.5,4.7-11.5,10.4v0.1c0,5.6,4.8,10.3,11.4,10.3
                c6.7,0,11.5-4.7,11.5-10.4v-0.1C201.7,32.1,196.9,27.4,190.3,27.4z M194.6,37.9c0,2.4-1.7,4.4-4.3,4.4c-2.6,0-4.4-2.1-4.4-4.5
                v-0.1c0-2.4,1.7-4.4,4.3-4.4C192.7,33.3,194.6,35.4,194.6,37.9L194.6,37.9z M231.6,27.4c-3,0-5.1,1.2-6.9,3.2
                c-1.1-2.1-3.2-3.2-6-3.2c-2.9,0-4.8,1.5-6.2,3.2v-2.7h-7.3v19.8h7.3V36.9c0-2.2,1.2-3.3,3-3.3c1.7,0,2.8,1.1,2.8,3.3v10.8h7.3
                V36.9c0-2.2,1.3-3.3,3-3.3c1.7,0,2.8,1.1,2.8,3.3v10.8h7.3v-13C238.7,30.1,236,27.4,231.6,27.4z M243.3,47.7h7.3V27.9h-7.3V47.7z
                M268,37.7l6.8-9.8h-7.7l-3.1,4.9l-3.1-4.9h-7.9l6.9,9.8l-7,10h7.7l3.3-5.1l3.2,5.1h7.8L268,37.7z M247.1,24.8
                c1.8,0,3.3-1.4,3.3-3.2c0-1.8-1.5-3.2-3.3-3.2c-1.8,0-3.3,1.4-3.3,3.2C243.7,23.4,245.2,24.8,247.1,24.8z M38.4,0
                C17.2,0,0,17,0,38c0,21,17.2,38,38.4,38c21.1,0,38.4-17,38.4-38C76.7,17,59.5,0,38.4,0z M38.4,72.5C19.2,72.5,3.6,57,3.6,38
                S19.2,3.6,38.4,3.6C57.5,3.6,73.1,19,73.1,38S57.5,72.5,38.4,72.5z M26.3,51.9c-3.9,0-7,3.1-7,6.9c0,3.8,3.1,6.9,7,6.9
                c3.9,0,7-3.1,7-6.9C33.2,55,30.1,51.9,26.3,51.9z M62.6,31.1c-3.9,0-7,3.1-7,6.9c0,3.8,3.1,6.9,7,6.9c3.9,0,7-3.1,7-6.9
                C69.6,34.2,66.5,31.1,62.6,31.1z M26.3,24.1c3.9,0,7-3.1,7-6.9c0-3.8-3.1-6.9-7-6.9c-3.9,0-7,3.1-7,6.9
                C19.3,21,22.4,24.1,26.3,24.1z M38.4,7.1c-2.3,0-4.5,0.2-6.7,0.7c3.3,1.9,5.5,5.4,5.5,9.4c0,1.6-0.4,3.1-1,4.4
                c0.7-0.1,1.4-0.1,2.1-0.1c6.9,0,12.9,4.2,15.4,10.2c2-2.7,5.2-4.5,8.9-4.5c2,0,3.9,0.6,5.5,1.5C64.1,16.1,52.3,7.1,38.4,7.1z
                M53.7,44.4c-2.5,6-8.5,10.2-15.4,10.2c-0.7,0-1.4-0.1-2.1-0.1c0.6,1.4,1,2.9,1,4.5c0,4-2.2,7.5-5.5,9.4c2.1,0.5,4.4,0.7,6.6,0.7
                c14,0,25.8-9.1,29.8-21.6c-1.6,0.9-3.5,1.5-5.5,1.5C58.9,48.9,55.7,47.1,53.7,44.4z M25.1,48c-2.2-2.8-3.5-6.3-3.5-10
                c0-3.8,1.3-7.2,3.4-10c-5.5-0.6-9.8-5.2-9.8-10.8c0,0,0,0,0-0.1C10.2,22.6,7.1,30,7.1,38c0,8,3.1,15.3,8.2,20.8c0,0,0,0,0,0
                C15.3,53.2,19.6,48.6,25.1,48z" fill="#ffffff"/>
            </g>
          </svg>

          <svg class="logo close" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
            <g fill="#ffffff">
              <path class="st0" d="M17.5,33.4c-8.7,0-15.9-7.1-15.9-15.9S8.8,1.6,17.5,1.6c8.7,0,15.9,7.1,15.9,15.9S26.2,33.4,17.5,33.4 M17.5,0
                C7.9,0,0,7.9,0,17.5S7.9,35,17.5,35C27.1,35,35,27.1,35,17.5S27.1,0,17.5,0"/>
              <path class="st0" d="M12,23.9c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2C15.2,25.3,13.7,23.9,12,23.9"/>
              <path class="st0" d="M28.6,14.3c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2
                C31.8,15.7,30.3,14.3,28.6,14.3"/>
              <path class="st0" d="M12,4.7c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2C15.2,6.2,13.7,4.7,12,4.7"/>
              <path class="st0" d="M17.5,3.2c-1,0-2.1,0.1-3,0.3C16,4.4,17,6.1,17,7.9c0,0.7-0.2,1.4-0.4,2c0.3,0,0.6-0.1,1-0.1
                c3.2,0,5.9,1.9,7,4.7c0.9-1.3,2.4-2.1,4-2.1c0.9,0,1.8,0.3,2.5,0.7C29.3,7.4,23.9,3.2,17.5,3.2"/>
              <path class="st0" d="M24.5,20.4c-1.1,2.7-3.9,4.7-7,4.7c-0.3,0-0.6,0-1-0.1c0.3,0.6,0.4,1.3,0.4,2.1c0,1.9-1,3.5-2.5,4.3
                c1,0.2,2,0.3,3,0.3c6.4,0,11.8-4.2,13.6-9.9c-0.7,0.4-1.6,0.7-2.5,0.7C26.9,22.5,25.4,21.7,24.5,20.4"/>
              <path class="st0" d="M7,7.9c-2.3,2.5-3.7,5.9-3.7,9.6c0,3.7,1.4,7.1,3.7,9.6c0,0,0,0,0,0c0-2.6,2-4.7,4.5-5c-1-1.3-1.6-2.9-1.6-4.6
                c0-1.7,0.6-3.3,1.6-4.6C8.9,12.6,7,10.5,7,7.9C7,7.9,7,7.9,7,7.9"/>
            </g>
          </svg>

        </a>
        <button class="toggle-menu" @click="toggleMenu"></button>
      </div>

      <e-menu class="sidebar-menu">
        <e-menu-header>Personal Area</e-menu-header>
        <e-menu-item label="Dashboard" route="dashboard" icon="dashboard"/>
        <e-menu-item label="Activity" icon="activity" route="activity"></e-menu-item>        
        <e-menu-item label="Community (Soon)" icon="community" disabled/>
        <e-menu-item label="Wallet (Soon)" icon="wallet" disabled/>

        <e-menu-header>Prediction</e-menu-header>
        <e-menu-item icon="rate" label="Rate" route="assets-list"/>
        <e-menu-item icon="forecast" label="Forecast" route="forecast-list"/>
        <e-menu-item icon="portfolio" label="Portfolio (Soon)" disabled/>

        <e-menu-header>Trading</e-menu-header>
        <e-menu-item label="Buy" icon="buy" route="trading-buy"/>
        <e-menu-item label="Sell (Soon)" icon="sell" disabled/>

        <e-menu-header>Settings</e-menu-header>
        <e-menu-item label="Account" icon="account" route="account"/>
        <e-menu-item label="Help" route="contacts" icon="help"/>
      </e-menu>

      <div class="sidebar-footer">
        <p class="copyright">Copyright © 2018-2026 ECONOMIX <br><a href="#">Terms of use</a> / <a href="#">Privacy Policy</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  import EMenuItem from "./menuItem";
  import EMenu from "./menu";
  import ESubmenuItem from "./subMenuItem";
  import EMenuHeader from "./menuHeader";

  import { mapGetters, mapState } from 'vuex';
  import {oneOf} from "@utils/assest";

  export default {
    name: "e-sidebar",
    components: {EMenuHeader, ESubmenuItem, EMenu, EMenuItem },
    props: {
      state: {
        type: String,
        validator (value) {
          return oneOf(value, ['close', 'open']);
        },
        default: 'open'
      },
      mobileOpen: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      updateViewport() {
        this.isMobile = window.innerWidth <= 767;
      },
      toggleMenu() {
        if (this.isMobile) {
          this.closeMobile();
          return;
        }

        this.isOpen = !this.isOpen;
        this.$emit("changeState", this.isOpen ? 'open' : 'close');
        // this.$root.$emit('ex::sidebar::toggleMenu', this.isOpen);
      },
      closeMobile() {
        if (this.isMobile && this.mobileOpen) {
          this.$emit("closeMobile");
        }
      }
    },
    computed: {
      ...mapState('settings', ['pageTitle']),
      classes() {
        return {
          'is-close': !this.isOpen && !this.isMobile,
          'is-mobile': this.isMobile,
          'is-mobile-open': this.mobileOpen,
        }
      }
    },
    watch: {
      $route() {
        this.closeMobile();
      }
    },
    beforeMount() {
      if(this.state === 'close') {
        this.isOpen = false;
      }
    },
    mounted() {
      this.updateViewport();
      window.addEventListener('resize', this.updateViewport);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateViewport);
    },
    data() {
      return {
        isOpen: true,
        isMobile: false,
      };
    }
  };
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/elements/sidebar/sidebar.vue